/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Connection,
  Connection$inboundSchema,
  Connection$Outbound,
  Connection$outboundSchema,
} from "./connection.js";

/**
 * The caller's connection, or its absence. Never carries the token.
 */
export type ConnectionEnvelope = {
  connection?: Connection | null | undefined;
};

/** @internal */
export const ConnectionEnvelope$inboundSchema: z.ZodType<
  ConnectionEnvelope,
  z.ZodTypeDef,
  unknown
> = z.object({
  connection: z.nullable(Connection$inboundSchema).optional(),
});
/** @internal */
export type ConnectionEnvelope$Outbound = {
  connection?: Connection$Outbound | null | undefined;
};

/** @internal */
export const ConnectionEnvelope$outboundSchema: z.ZodType<
  ConnectionEnvelope$Outbound,
  z.ZodTypeDef,
  ConnectionEnvelope
> = z.object({
  connection: z.nullable(Connection$outboundSchema).optional(),
});

export function connectionEnvelopeToJSON(
  connectionEnvelope: ConnectionEnvelope,
): string {
  return JSON.stringify(
    ConnectionEnvelope$outboundSchema.parse(connectionEnvelope),
  );
}
export function connectionEnvelopeFromJSON(
  jsonString: string,
): SafeParseResult<ConnectionEnvelope, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectionEnvelope$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectionEnvelope' from JSON`,
  );
}
